import { useMutation } from '@tanstack/react-query'
import { getAiRecommendThumbnailTitle } from 'service/list'

function useGetAiRecommendThumbnailTitle() {
  return useMutation({
    mutationKey: ['get-ai-recommend-thumbnail-title'],
    mutationFn: getAiRecommendThumbnailTitle,
  })
}

export default useGetAiRecommendThumbnailTitle
